<div class="status-bar" *ngIf="user$ | async as user">
  <div class="user-box">
    <div class="account-icon">
      <div class="profile-image image-container" [style.background-image]="'url('+(user.profileImageUrl)+')'"
        *ngIf="user.profileImageUrl; else profileIcon" alt="Profile image"></div>
      <ng-template #profileIcon>
        <mat-icon [inline]="true" svgIcon="profile"></mat-icon>
      </ng-template>
    </div>
    <div class="menu-trigger" [matMenuTriggerFor]="userMenu">
      <div class="user-information">
        <p class="name">{{ user.fullName }}</p>
        <p class="role">{{ toReadableUserRole(user.role) }}</p>
      </div>
      <mat-icon class="arrow" svgIcon="arrow_down"></mat-icon>
    </div>
  </div>
  <mat-menu class="status-bar-menu" #userMenu="matMenu" [overlapTrigger]="false">
    <a mat-menu-item class="status-bar-menu-link" [routerLink]="accountUrl$ | async">
      My Account
    </a>
    <a mat-menu-item class="status-bar-menu-link" [routerLink]="helpUrl$ | async">
      Help
    </a>
    <a mat-menu-item *ngxPermissionsOnly="[userRoles.Admin]" class="status-bar-menu-link"
      [routerLink]="queryType$ | async">
      Commonly Asked Questions
    </a>
    <a mat-menu-item *ngxPermissionsOnly="[userRoles.Admin]" class="status-bar-menu-link"
      [routerLink]="permission$ | async">
      Permission
    </a>
    <a mat-menu-item *ngxPermissionsOnly="[userRoles.Admin]" class="status-bar-menu-link"
    [routerLink]="productconfiguration$ | async">
    Product Configuration
  </a>
  <a mat-menu-item *ngxPermissionsOnly="[userRoles.Admin]" class="status-bar-menu-link"
  [routerLink]="emailsubscription$ | async">
  Email Subscription
</a>
    <a mat-menu-item *ngxPermissionsOnly="[userRoles.Admin]" class="status-bar-menu-link"
      [routerLink]="configuration$ | async">
      Configuration
    </a>
    <!--<div *ngIf="!hideUpgradePlan">
      <a mat-menu-item *ngxPermissionsOnly="[userRoles.Realtor, userRoles.LoanOfficer]" class="status-bar-menu-link"
        [routerLink]="plan$ | async">
        Upgrade Plan
      </a>
    </div>-->
    <a mat-menu-item *ngxPermissionsOnly="[userRoles.Admin]" class="status-bar-menu-link"
      [routerLink]="paymentSummary$ | async">
      Payment Summary
    </a>
    <!--<div *ngIf="!hideUpgradePlan">
    <a mat-menu-item *ngxPermissionsOnly="[userRoles.Realtor, userRoles.LoanOfficer]" class="status-bar-menu-link"
      [routerLink]="paymentInfo$ | async">
      Payment Info
    </a>
    </div>-->

    <!-- <a mat-menu-item
       class="status-bar-menu-link"
       routerLink="/mail_templates/list" style="display: none;">
      My Templates
    </a> -->
    <button mat-menu-item type="button" class="status-bar-menu-link" (click)="logout()">
      Logout
    </button>


  </mat-menu>

</div>


<!-- Badge Login -->
<!-- &nbsp;<span class="badge-icon">{{userTypeText}}</span> -->